<template>
<div class="input-item">
  <div class="input-item-one">
    <div class="input-item-label">{{label}}:</div>
    <div class="input-item-value input-item-value-protocol">
      <slot></slot>
    </div>
  </div>
  <div class="input-item-tips"><div>{{errTips}}</div></div>
</div>
</template>

<script>

export default {
  name: "sessionNew",
  props: ["label", "errTips"]
}
</script>


<style scoped>
.input-item {
  width: 100%;
  padding: 1em 0.5em;
  
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.input-item-one {
  width: 100%;
  display: flex;
  align-items: center;
}
.input-item-label {
  flex-grow: 0;
  padding-right: 0.5em;
  word-break: keep-all;

  user-select: none;
}
.input-item-value {
  flex-grow: 1;

  display: flex;
}
.input-item-tips {
  width: 100%;
  padding-top: 0.6em;
  font-size: 0.8em;

  display: flex;
  justify-content: flex-end;
  color:brown;
}
</style>